import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'; // React Router se params lene ke liye

const Field = ({ label, value }) => (
  <div className="grid grid-cols-12 text-sm py-1">
    <div className="col-span-4 text-gray-600">{label}</div>
    <div className="col-span-8 font-medium text-gray-900">{value || '—'}</div>
  </div>
);

const Section = ({ title, children }) => (
  <section className="mb-8">
    <div className="flex items-center gap-3 mb-3">
      <div className="flex-1 h-px bg-gray-300" />
      <h3 className="text-xs font-semibold tracking-widest text-gray-700 uppercase">{title}</h3>
      <div className="flex-1 h-px bg-gray-300" />
    </div>
    <div className="space-y-2">{children}</div>
  </section>
);

const ImageFrame = ({ label, src, height }) => (
  <div>
    <p className="text-[11px] text-gray-500 mb-1">{label}</p>
    <div className={`border border-gray-300 bg-white ${height}`}>
      {src ? (
        <img src={src} alt={label} className="w-full h-full object-cover" />
      ) : (
        <div className="h-full flex items-center justify-center text-gray-400 text-xs">Not Available</div>
      )}
    </div>
  </div>
);

const SeamanRegistrationdetails = () => {
  const { id } = useParams();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const server = process.env.REACT_APP_API_URL;
  const colors = ['#e3f2fd', '#fce4ec', '#e8f5e9', '#fff3e0', '#f3e5f5', '#e0f2f1', '#f9fbe7'];

  const getRandomColor = () => colors[Math.floor(Math.random() * colors.length)];

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${server}/api/seamanregistration/${id}`);
        setData(response.data);
      } catch (err) {
        setError(err.response?.data?.message || err.message || 'Failed to fetch data');
      } finally {
        setLoading(false);
      }
    }
    if (id) {
      fetchData();
    }
  }, [id, server]);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading application details...</div>;

  if (error) return <div className="min-h-screen flex items-center justify-center text-red-500">Error: {error}</div>;

  if (!data) return <div className="min-h-screen flex items-center justify-center text-gray-500">No data found.</div>;

  const d = data;

  const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  console.log('date-->',day,month,year)
  return `${day}/${month}/${year}`;
};
  return (
    <div className="min-h-screen py-8">
      <div className="max-w-6xl mx-auto bg-white border border-gray-300 shadow-sm">
        {/* HEADER */}
        <header className="px-8 py-5 border-b border-gray-300">
          <h1 className="text-lg font-semibold tracking-wide text-gray-900 text-center">SEAMAN REGISTRATION APPLICATION</h1>
          <div className="mt-2 flex justify-between text-xs text-gray-600">
            <span>
              Application No: <strong className="text-gray-800">{d.applicationNo}</strong>
            </span>
            {/* <span>{new Date(formatDate(d.createdAt)).toLocaleDateString()}</span> */}
            <span>{formatDate(d.createdAt)}</span>
          </div>
        </header>

        {/* BODY */}
        <div className="grid grid-cols-12 gap-6 px-8 py-8">
          {/* LEFT SIDE (MAIN DETAILS) */}
          <div className="col-span-9">
            <Section title="Personal Information">
              <Field label="First Name" value={d.candidateFirstName} />
              <Field label="Middle Name" value={d.candidateMiddleName} />
              <Field label="Last Name" value={d.candidateLastName} />
              <Field label="Gender" value={d.gender} />
              <Field label="Date of Birth" value={d.dateOfBirth} />
              <Field label="Place of Birth" value={d.placeOfBirth} />
              <Field label="Nationality" value={d.nationality} />
              <Field label="Height (cm)" value={d.height} />
              <Field label="Weight (kg)" value={d.weight} />
            </Section>

            <Section title="Contact Information">
              <Field label="Mobile Number" value={d.contactNumber} />
              <Field label="WhatsApp Number" value={d.whatsAppNumber} />
              <Field label="Email Address" value={d.email} />
            </Section>

            <Section title="Address Details">
              <Field label="Permanent Address" value={d.permanentAddress} />
              <Field label="Permanent Pincode" value={d.permanentPincode} />
              <Field label="Permanent City" value={d.permanentCity} />
              <Field label="Permanent State" value={d.permanentState} />

              <Field label="Current Address" value={d.currentAddress} />
              <Field label="Current Pincode" value={d.currentPincode} />
              <Field label="Current City" value={d.currentCity} />
              <Field label="Current State" value={d.currentState} />
            </Section>

            <Section title="Passport & Identity">
              <Field label="Passport Number" value={d.CandidatepassportNo} />
              <Field label="Place of Issue" value={d.CandidatePassportplaceOfIssue} />
              <Field label="Passport Expiry Date" value={d.CandidatePassportexpiryDate} />
              <Field label="INDOS Number" value={d?.IndosNumber} />
              <Field label="Us Visa Available" value={d?.haveUsVisa} />

              {d?.haveUsVisa === 'Yes' && (
                <>
                  <Field label="US Visa Date Of Issue" value={d?.UsVisadateOfIssue} />
                  <Field label="US Visa Place Of Issue" value={d?.UsVisaplaceOfIssue} />
                  <Field label="US Visa Expiry Date" value={d?.UsVisaexpiryDate} />
                  <Field label="MUI Number" value={d?.MuiNumber} />
                  <Field label="Membership" value={d?.MemberShip} />
                </>
              )}
            </Section>

            {/* Seaman Book Details */}
            <Section title="Seaman Book Details">
              {d?.seabookDetails.map((c, i) => (
                <div key={i} className="grid grid-cols-1 border border-gray-200 p-3 mb-3 rounded-md">
                  <Field label="Nationality" value={c.seabookCdcNationality || '-'} />
                  <Field label="Number" value={c.seabookCdcNationalityNumber || '-'} />
                  <Field label="Place Of Issue" value={c.seabookCdcNationalityPlaceofIssue || '-'} />
                  <Field label="Date Of Issue" value={c.seabookCdcNationalitydateOfIssue || '-'} />
                  <Field label="Date Of Expiry" value={c.seabookCdcNationalitydateOfExpiry || '-'} />
                </div>
              ))}

              {/* Indos Details */}

              <Section title="Indos Details">
                <div className="grid grid-cols-1 border border-gray-200 p-3 mb-3 rounded-md">
                  <Field label="Number" value={d?.IndosNumber || '-'} />
                  <Field label="Place Of Issue" value={d?.IndosPlaceOfIssue || '-'} />
                  <Field label="Date Of Issue" value={d?.IndosDateOfIssue || '-'} />
                </div>
              </Section>
              {/* Sid Details */}

              <Section title="Sid Details">
                <div className="grid grid-cols-1 border border-gray-200 p-3 mb-3 rounded-md">
                  <Field label="Number" value={d?.SidNumber || '-'} />
                  <Field label="Place Of Issue" value={d?.IndosPlaceOfIssue || '-'} />
                  <Field label="Date Of Issue" value={d?.IndosDateOfIssue || '-'} />
                  <Field label="Date Of Expiry" value={d?.SidDateOfExpiry || '-'} />
                </div>
              </Section>

              {/* Yellow Fever Details */}
              <Section title="Yellow Fever">
                <div className="grid grid-cols-1 border border-gray-200 p-3 mb-3 rounded-md">
                  <Field label="Number" value={d?.YellowFeverCertificateNumber || '-'} />
                  <Field label="Place Of Issue" value={d?.YellowFeverPlaceOfIssue || '-'} />
                  <Field label="Date Of Issue" value={d?.YellowFeverDateOfIssue || '-'} />
                  <Field label="Date Of Expiry" value={d?.YellowFeverDateOfExpiry || '-'} />
                </div>
              </Section>
            </Section>

            <Section title="License Details">
              {d?.licenseDetails.map((c, i) => (
                <div key={i} className="grid grid-cols-1 border border-gray-200 p-3 mb-3 rounded-md">
                  <Field label="Name" value={c?.licenseName || '-'} />
                  <Field label="Grade" value={c?.licenseGrade || '-'} />
                  <Field label="Number" value={c?.licenseNumber || '-'} />
                  <Field label="Date Of Issue" value={c?.licenseDateOfIssue || '-'} />
                    <Field label="Date Of Expiry" value={c?.licenseDateOfExpiry || '-'} />
                  <Field label="Country Of Issue" value={c?.licenseCountryOfIssue || '-'} />
                </div>
              ))}
            </Section>

            {/* Sea Service Experience */}
            <Section title="Sea Service Experience">
              {d?.seaserviceExperience.map((c, i) => (
                <div key={i} className="grid grid-cols-1 border border-gray-200 p-3 mb-3 rounded-md">
                  <Field label="EXperience Owner" value={c?.seaserviceExperienceOwner || '-'} />
                  <Field label="Owner IMO" value={c?.seaserviceExperienceOwnerImo || '-'} />
                  <Field label="Type Of Vessel" value={c?.seaserviceExperienceOwnerTypeOfVessel || '-'} />
                  <Field label="GRT" value={c?.seaserviceExperienceGrt || '-'} />
                  <Field label="BHP" value={c?.seaserviceExperienceBhp || '-'} />
                  <Field label="Engine Type" value={c?.seaserviceExperienceOwnerEngineType || '-'} />
                  <Field label="UMS" value={c?.seaserviceExperienceUms || '-'} />
                  <Field label="Rank" value={c?.seaserviceExperienceRank || '-'} />
                  <Field label="Sign On" value={c?.seaserviceExperienceSignOn || '-'} />
                  <Field label="Sign Off" value={c?.seaserviceExperienceSignOff || '-'} />
                  <Field label="Total Experience" value={c?.seaserviceExperienceTotal || '-'} />
                  <Field label="Region" value={c?.seaserviceExperienceRegion || '-'} />
                </div>
              ))}
            </Section>

            <Section title="Medical History">
              <Field label="Have you ever signed off from a ship due to medical reasons?" value={d?.signedOff || '-'} />
              <Field label="Region" value={d?.disease || '-'} />
              <Field label="Region" value={d?.addiction || '-'} />
              <Field
                label="Have you suffered from any disease?"
                value={
                  d?.illnesses?.length ? (
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                      {d.illnesses.map((item, index) => (
                        <span
                          key={index}
                          style={{
                            backgroundColor: getRandomColor(),
                            padding: '4px 10px',
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: 500,
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {item}
                        </span>
                      ))}
                    </div>
                  ) : (
                    '-'
                  )
                }
              />

              <Field label="Did you ever undergo psychiatric treatment?" value={d?.psychiatric || '-'} />
              <Field label="How did you come to know about BMS Shipping?" value={d?.source || '-'} />
                 <Field label="Do you know Swimming?" value={d?.swimming || '-'} />
            </Section>

            <Section title="Family Information">
              <div className="grid grid-cols-4 gap-x-8 text-sm font-medium text-gray-700 mb-6">
                {/* Father Labels */}
                <div className="text-left pr-4">Father First Name</div>
                <div className="font-semibold text-gray-900">{d.fatherFirstName || '-'}</div>

                {/* Mother Labels */}
                <div className="text-left pr-4">Mother First Name</div>
                <div className="font-semibold text-gray-900">{d.motherFirstName || '-'}</div>

                {/* Father Middle Name */}
                <div className="text-left pr-4">Middle Name</div>
                <div className="font-semibold text-gray-900">{d.fatherMiddleName || '-'}</div>

                {/* Mother Middle Name */}
                <div className="text-left pr-4">Middle Name</div>
                <div className="font-semibold text-gray-900">{d.motherMiddleName || '-'}</div>

                {/* Father Last Name */}
                <div className="text-left pr-4">Last Name</div>
                <div className="font-semibold text-gray-900">{d.fatherSurname || '-'}</div>

                {/* Mother Last Name */}
                <div className="text-left pr-4">Last Name</div>
                <div className="font-semibold text-gray-900">{d.motherSurname || '-'}</div>
              </div>

              {/* Marital Status */}
              <Field label="Marital Status" value={d.civilStatus || '-'} />

              {d.civilStatus === 'Married' && (
                <div className="pl-6 mt-4 border-l-2 border-gray-300">
                  <Section title="Spouse Details">
                    <Field label="Spouse Name" value={d.spouseDetails?.spouseName || '-'} />
                    <Field label="Spouse Date of Birth" value={d.spouseDetails?.spouseDateOfBirth || '-'} />
                    <Field label="Spouse Contact" value={d.spouseDetails?.spouseContact || '-'} />
                    <Field label="Spouse WhatsApp" value={d.spouseDetails?.spouseWhatsapp || '-'} />
                    <Field label="Spouse Email" value={d.spouseDetails?.spouseEmail || '-'} />
                    <Field label="Spouse Address" value={d.spouseDetails?.spouseAddress || '-'} />
                    <Section title="Spouse Passport Details">
                      <Field label="Spouse Passport Available" value={d.spouseDetails?.spousePassportAvailable || '-'} />
                      <Field label="Spouse Passport Number" value={d.spouseDetails?.spousePassportNo || '-'} />
                      <Field label="Spouse Passport Date of Issue" value={d.spouseDetails?.spousePassportDateOfIssue || '-'} />
                      <Field label="Spouse Passport Place of Issue" value={d.spouseDetails?.spousePassportPlaceOfIssue || '-'} />
                      <Field label="Spouse Passport Expiry Date" value={d.spouseDetails?.spousePassportExpiryDate || '-'} />
                    </Section>
                  </Section>
                </div>
              )}

              {d.children?.length > 0 && (
                <div className="mt-6 flex flex-col">
                  <p className="text-xs font-semibold text-gray-700 mb-2 uppercase">Children Details</p>
                  {/* <div className="flex gap-2"> */}

                  {d.children.map((c, i) => (
                    <div key={i} className="grid grid-cols-1 border border-gray-200 p-3 mb-3 rounded-md">
                      <Field label="Relation" value={c.relation || '-'} />
                      <Field label="Child Name" value={c.childName || '-'} />
                      <Field label="Date of Birth" value={c.dateOfBirth || '-'} />
                      <Field label="Passport No" value={c.passportNo || '-'} />
                      <Field label="Date Of Issue" value={c.dateOfIssue || '-'} />
                      <Field label="Place Of Issue" value={c.placeOfIssue || '-'} />
                      <Field label="Expiry Date" value={c.expiryDate || '-'} />
                    </div>
                  ))}
                  {/* </div> */}

                  <Section title="Emergency Contact Information">
                    <Field label="Emergency Contact 1 Name" value={d.EmergencyContactName1 || '-'} />
                    <Field label="Emergency Contact 1 Relation" value={d.EmergencyContactRelation1 || '-'} />
                    <Field label="Emergency Contact 1 Contact" value={d.EmergencyContactContactNo1 || '-'} />
                    <Field label="Emergency Contact 1 Email" value={d.EmergencyContactEmail1 || '-'} />
                    <Field label="Emergency Contact 1 Address" value={d.EmergencyContactAddress1 || '-'} />

                    {/* Contact 2  */}

                    <Field label="Emergency Contact 2 Name" value={d.EmergencyContactName2 || '-'} />
                    <Field label="Emergency Contact 2 Relation" value={d.EmergencyContactRelation2 || '-'} />
                    <Field label="Emergency Contact 2 Contact" value={d.EmergencyContactContactNo2 || '-'} />
                    <Field label="Emergency Contact 2 Email" value={d.EmergencyContactEmail2 || '-'} />
                    <Field label="Emergency Contact 2 Address" value={d.EmergencyContactAddress2 || '-'} />

                    {/* Education Details */}

                    <Section title="Education Details">
                      {/* {d.exam10th.map((c, i) => ( */}
                      <div className="grid grid-cols-1">
                        <Field label="10th Board/University" value={d?.exam10th?.boardUniversity || '-'} />

                        <Field label="10th Year Of Passing" value={d?.exam10th?.yearOfPassing || '-'} />
                        <Field label="10th Subjects Stream" value={d?.exam10th?.subjectsStream || '-'} />
                        <Field label="10th Percentage" value={d?.exam10th?.percentage || '-'} />
                        <Field label="10th English Marks" value={d?.exam10th?.englishMarks || '-'} />

                        <Field label="12th Board/University" value={d?.exam12th?.boardUniversity || '-'} />
                        <Field label="12th Year Of Passing" value={d?.exam12th?.yearOfPassing || '-'} />
                        <Field label="12th Subjects Stream" value={d?.exam12th?.subjectsStream || '-'} />
                        <Field label="12th Percentage" value={d?.exam12th?.percentage || '-'} />
                        <Field label="12th English Marks" value={d?.exam12th?.englishMarks || '-'} />

                        <Field label="Diploma/Degree Board/University" value={d?.diplomaDegree?.boardUniversity || '-'} />
                        <Field label="Diploma/Degree Year Of Passing" value={d?.diplomaDegree?.yearOfPassing || '-'} />
                        <Field label="Diploma/Degree Subjects Stream" value={d?.diplomaDegree?.subjectsStream || '-'} />
                        <Field label="Diploma/Degree Percentage" value={d?.diplomaDegree?.percentage || '-'} />
                        <Field label="Diploma/Degree English Marks" value={d?.diplomaDegree?.englishMarks || '-'} />
                      </div>
                      {/* ))} */}

                      {/* Basic Course Details */}
                      <Section title="Basic Course Details">
                        {d.basicCourses.map((c, i) => (
                          <div key={i} className="grid grid-cols-1 border border-gray-200 p-3 mb-3 rounded-md">
                            <Field label="Course Name" value={c.courseName || '-'} />
                            <Field label="Number" value={c.number || '-'} />
                            <Field label="Date Of Issue" value={c.dateOfIssue || '-'} />
                            <Field label="Date Of Expiry" value={c.dateOfExpiry || '-'} />
                            <Field label="Issued By" value={c.issuedBy || '-'} />
                          </div>
                        ))}
                      </Section>

                      <Section title="Dangerous Endourcement Details">
                        {d.dangerousEndourcementDetails.map((c, i) => (
                          <div key={i} className="grid grid-cols-1 border border-gray-200 p-3 mb-3 rounded-md">
                            <Field label="Type" value={c.dangerousEndourcementType || '-'} />
                            <Field label="Grade" value={c.dangerousEndourcementGrade || '-'} />
                            <Field label="Number" value={c.dangerousEndourcementNumber || '-'} />
                            <Field label="Date Of Issue" value={c.dangerousEndourcementdateOfIssue || '-'} />
                            <Field label="Date Of Expiry" value={c.dangerousEndourcementdateOfExpiry || '-'} />
                          </div>
                        ))}

                        <Section title="Welldor & Fitter">
                          <Field label="Certificate No." value={d?.WellFitterCertificateNumber || '-'} />
                          <Field label="Place Of Issue" value={d?.WellFitterPlaceOfIssue || '-'} />
                          <Field label="Date Of Issue" value={d?.WellFitterDateOfIssue || '-'} />
                          <Field label="Date Of Expiry" value={d?.WellFitterDateOfExpiry || '-'} />
                        </Section>
                      </Section>

                      {/* Dangerous endourcement */}
                    </Section>
                  </Section>
                </div>
              )}
            </Section>
          </div>

          {/* RIGHT SIDE (PHOTO PANEL) */}
          <div className="col-span-3">
            <div className="border border-gray-300 bg-gray-50 p-3 sticky top-6">
              <ImageFrame label="Candidate Photograph" src={d.CandidateImage} height="h-40" />

              <div className="mt-6">
                <ImageFrame label="Applicant Signature" src={d.SignatureImage} height="h-24" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeamanRegistrationdetails;
